import React from 'react';
import { bool, shape, string } from 'prop-types';

const TableColor = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.625 2.25H3.375C2.55 2.25 1.875 2.925 1.875 3.75V14.25C1.875 15.075 2.55 15.75 3.375 15.75H14.625C15.45 15.75 16.125 15.075 16.125 14.25V3.75C16.125 2.925 15.45 2.25 14.625 2.25ZM14.625 3.75V6H3.375V3.75H14.625ZM7.125 14.25H10.875V7.5H7.125V14.25ZM3.375 7.5H5.625V14.25H3.375V7.5ZM12.375 7.5V14.25H14.625V7.5H12.375Z" fill="currentColor" />
  </svg>
);

TableColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default TableColor;
